import React from "react";
import { useLocalizedText } from "../../../utils/hooks/useLocalizedText";
import { Stack } from "react-bootstrap";
import { countryCodeMap } from "../../../Pages/Campaigns/data";
import { useCachedBasicData } from "@/utils/hooks/useCachedBasicData";

export const useOptions = () => {
  // ==========
  // hooks
  // ==========
  const { getLocalizedText, getLocalizedNumber } = useLocalizedText();
  // ==========
  // Query && Data
  // ==========
  const { cachedBasicData, basicDataResponse, contractsDataResponse } =
    useCachedBasicData();
  const { isLoading: isBasicDataLoading, isFetching: isBasicDataFetching } =
    basicDataResponse;
  const { isLoading: isContractsLoading, isFetching: isContractsFetching } =
    contractsDataResponse;
    
  const isLoading =
    isBasicDataLoading ||
    isBasicDataFetching ||
    isContractsLoading ||
    isContractsFetching;

  const options = cachedBasicData.nationalities?.map((country) => {
    return {
      q: country.q,
      value: country?.id,
      label: (
        <Stack direction="horizontal" gap={1} style={{ textWrap: "nowrap" }}>
          <i
            className={`flag-icon flag-icon-${countryCodeMap[
              country.id
            ]?.toLowerCase()}`}
          ></i>
          {[
            getLocalizedNumber(country.id),
            getLocalizedText(country?.name_ar, country?.name_en),
          ].join(" - ")}
        </Stack>
      ),
    };
  });

  return { options, isLoading };
};
